const target = new EventTarget()

export function showHelp(route: string) {
  target.dispatchEvent(new CustomEvent('show', { detail: route }))
}

export function onShowHelp(handler: (route: string) => void) {
  const listener = (event: Event) => handler((event as CustomEvent<string>).detail)
  target.addEventListener('show', listener)
  return () => target.removeEventListener('show', listener)
}
